module.exports = __webpack_public_path__ + "img/light.ccbb6cbd.svg";